import script from "./PlayNotes.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayNotes.vue?vue&type=script&setup=true&lang=js"

import "./PlayNotes.vue?vue&type=style&index=0&id=e8633626&lang=css"

const __exports__ = script;

export default __exports__